<template>
  <div class = "mainContainer">
    <p class = "escrowText">Escrow Balance</p>
    <span class = "escrowAmount">&#x20B9;{{escrowAmount | localeAmount }}</span>
    <span class = "planLine"></span>
    <div class = "subContainer mb-5">
        <div class = "smallContainer">
            <p class = "subText">Deposit</p>
            <span class = "subAmountText">&#x20B9;{{escrowAmount - incomeAmount| localeAmount }}</span>
        </div>
        <div class = "buttonContainer">
            <button :disabled='(escrowAmount - incomeAmount) <= 0' class = "buttonInvest btn_new btn-secondary-new" @click="investCalled(true, false)">
                <span class="buttonInvestText">Invest</span>
            </button>
            <!-- <button :disabled='(escrowAmount - incomeAmount) <= 0'  class = "buttonSubmit btn_new btn-secondary-new" @click="withdrawCalled('escrowBalance')">
                    <span class = "buttonText">Withdraw</span>
            </button> -->
        </div>
    </div>
    <div class = "subContainer">
        <div class = "smallContainer">
            <p class = "subText">Monthly Repayment</p>
            <span class = "subAmountText">&#x20B9;{{incomeAmount | localeAmount }}</span>
        </div>
        <div class = "buttonContainer">
            <button :disabled='incomeAmount <= 0' class = "buttonInvest btn_new btn-secondary-new" @click="investCalled(false, true)">
                <span v-if = "incomeAmount <= 0" class = "colorButton">Reinvest</span>
                <span v-else class = "buttonInvestText">Reinvest</span>
            </button>
            <button v-if = "accountStatus !== 'FROZEN' " :disabled='incomeAmount <= 0' class = "buttonSubmit btn_new btn-secondary-new" @click="withdrawCalled('income')">
                <span class = "buttonText">Withdraw</span>
            </button>
        </div>
    </div>
    <p v-if = "accountStatus === 'FROZEN' " class = "frozenText">Your Account has been frozen! Please contact customer support</p>
  </div>
</template>

<script>

export default {
    props: {
        incomeAmount: Number,
        escrowAmount: Number
    },
    data () {
        return {
            accountStatus: null
        }
    },
    mounted () {
        this.accountStatus = this.$store.getters['dashboard/getAccountStatus']
    },
    methods: {
        withdrawCalled (withdrawType) {
            this.$emit('withdrawCalled', withdrawType)
        },
        investCalled (isEscrow, isMonthly) {
            this.$emit('investCalled', isEscrow, isMonthly)
        }
    }
}
</script>

<style lang="scss" scoped>

    .frozenText {
        color: red
    }
    .paddingLeft {
        margin-left: 10px
    }
    .buttonContainer {
        display: flex;
        flex-direction: row;
        gap: 5px
    }
    .escrowText {
        font-weight: 500;
        font-size: 21px;
        color: #0F0F0F;
    }
    .mainContainer {
        margin-bottom: 40px;
        display: flex;
        flex-direction: column;
        align-items: center;
    }
    .escrowAmount {
        font-weight: 600;
        font-size: 28px;
        color: #232323;
        margin-bottom : 8px
    }
    .planLine {
        width: 100%;
        text-align: left;
        border-bottom: 1px solid #e0e0e0;
        line-height: 0.1em;
        margin: 10px 0 20px;
        margin-bottom : 26px !important
    }
    .subContainer {
        margin: 16px;
        align-items: center;
        display: flex;
        flex-direction: row;
        width: -webkit-fill-available;
        background: #F2F6FF;
        border-radius: 1px;
        padding: 8px;
        padding-left: 16px !important;
        padding-right: 16px !important;
    }
    .smallContainer {
        width: 100%;
        display: flex;
        flex-direction: column;
    }
    .subText {
        margin-bottom: 8px !important;
        font-weight: 400;
        font-size: 12px;
        color: #4F4F4F;
    }
    .subAmountText {
        font-weight: 700;
        font-size: 17px;
        color: #232323;
    }
    .buttonSubmit {
        height: 34px !important;
        font-size: 12px !important;
        min-width: 75px !important;
        max-width: 75px !important;
    }
    .buttonText {
        line-height: 0px;
        display: grid;
    }

    .buttonInvestText {
        color: #002FA7 !important;
        line-height: 0px;
        display: grid;
    }
    .colorButton {
        color: #999999;
        line-height: 0px;
        display: grid;
    }

    .buttonInvest {
        background-color: #F2F6FF !important;
        height: 34px !important;
        font-size: 12px !important;
        min-width: 75px !important;
        max-width: 75px !important;
    }

    @media (max-width: 480px) {
        .subContainer {
            margin: 7px !important;
            padding: 8px;
        }
        .paddingLeft {
            margin-left: 5px !important
        }
    }

</style>
